export const SITE_TITLE = process.env.VUE_APP_TITLE || '百年票票';

export const SITE_SLOGAN = '西安本地官方直营 · 王牌演艺特惠 · 精品一日游';

export const SITE_INTRO =
  '百年票票专注西安本地文旅票务服务，为您提供长恨歌、驼铃传奇、千古情三大王牌演艺特惠票，丝路欢乐世界优惠门票，以及兵马俑、骊山、华清宫一日游精心安排，给您超棒旅行体验。';

export const SITE_DESCRIPTION =
  '百年票票 - 西安本地官方直营文旅票务平台，长恨歌、驼铃传奇、千古情三大王牌演艺特惠票，丝路欢乐世界优惠门票，兵马俑骊山华清宫一日游。';

export const SITE_KEYWORDS =
  '百年票票,西安票务,长恨歌,驼铃传奇,千古情,丝路欢乐世界,西安旅游,演艺门票,一日游,华清宫,兵马俑';

export const DEFAULT_APP_CONFIG = {
  contactPhone: '029-8888-8888',
  serviceHours: '周一至周日 9:00 - 21:00'
};
